import React from "react";
import curve from "../../assets/icons/curvyline.svg";
import dot from "../../assets/icons/dot.svg";

const Topsection = () => {
	return (
		<section className='lg:pt-40 pt-24 pb-16 relative'>
			{/* Title and Description */}
			<div className=' text-center'>
				<h1 className='lg:text-[72px]/[79px] text-[40px]/[49px] lg:tracking-[-2px] tracking-[-1.72px] font-medium text-[#11112D] mb-4  mx-auto'>
					Join Us In Transforming Lives
				</h1>

				<img
					src={curve}
					alt='Curve Decoration'
					className='hidden md:block absolute top-0 right-0 w-[150px] md:w-[200px] lg:w-[250px]'
				/>
			</div>
			<div className='flex flex-col items-center mt-4 relative'>
				{/* Paragraph Section */}
				<p className='w-[90%] md:w-1/2 text-center text-lg text-[#11112d] font-normal mb-8'>
					At SynergyCare Foundation, we believe in the power of collective
					action. Here are ways you can make a difference:
				</p>
				<img
					src={dot}
					alt='Icon 2'
					className='absolute top-0 left-0 md:flex hidden'
				/>
			</div>
		</section>
	);
};

export default Topsection;
